// Shows a stored photo, or a calm coloured placeholder with an icon (content has no photos).
import React from 'react';
import { Image, View, type StyleProp, type ViewStyle } from 'react-native';
import Icon, { type IconName } from './Icon';
import { usePhotoUri } from '../platform/media';
import { PHOTO_TINTS, radius, usePalette } from '../theme';
import type { MediaRef } from '../types';

function hash(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
  return Math.abs(h);
}

export default function Photo({
  media, seed, icon = 'recipe', style, rounded = true, iconSize = 32,
}: { media?: MediaRef; seed: string; icon?: IconName; style?: StyleProp<ViewStyle>; rounded?: boolean; iconSize?: number }) {
  const uri = usePhotoUri(media);
  const p = usePalette();
  const r = rounded ? radius.l : 0;
  const tints = PHOTO_TINTS[p.decor === 'matrix' ? 'matrix' : p.scheme];
  if (uri) {
    return (
      <View style={[{ overflow: 'hidden', borderRadius: r, backgroundColor: p.card }, style]}>
        <Image source={{ uri }} style={{ width: '100%', height: '100%' }} resizeMode="cover" accessibilityIgnoresInvertColors />
      </View>
    );
  }
  return (
    <View style={[{ borderRadius: r, backgroundColor: tints[hash(seed) % tints.length], alignItems: 'center', justifyContent: 'center' }, style]}>
      <Icon name={icon} size={iconSize} color={p.decor === 'matrix' ? p.secondaryText : p.scheme === 'dark' ? 'rgba(255,255,255,0.45)' : 'rgba(0,0,0,0.4)'} strokeWidth={1.5} />
    </View>
  );
}
